export var DataType;
(function (DataType) {
    let Name;
    (function (Name) {
        Name["Null"] = "NULL";
        Name["Boolean"] = "BOOLEAN";
        Name["Float"] = "FLOAT";
        Name["Integer"] = "INTEGER";
        Name["Decimal"] = "DECIMAL";
        Name["Numeric"] = "NUMERIC";
        Name["String"] = "STRING";
        Name["Regexp"] = "REGEXP";
        Name["Timestamp"] = "TIMESTAMP";
        Name["DateTime"] = "DATE_TIME";
    })(Name = DataType.Name || (DataType.Name = {}));
    function equals(type1, type2) {
        switch (type1.name) {
            case "NULL":
                return type1.name === type2.name;
            case "BOOLEAN":
                return type1.name === type2.name;
            case "FLOAT":
                return type1.name === type2.name;
            case "INTEGER":
                return type1.name === type2.name;
            case "DECIMAL":
                return (type1.name === type2.name &&
                    type1.scale === type2.scale &&
                    type1.precision === type2.precision);
            case "STRING":
                return type1.name === type2.name;
            case "REGEXP":
                return type1.name === type2.name;
            case "TIMESTAMP":
                return type1.name === type2.name && type1.unit === type2.unit;
            case "DATE_TIME":
                return type1.name === type2.name && type1.format === type2.format;
            default:
                return false;
        }
    }
    DataType.equals = equals;
    let NullType;
    (function (NullType) {
        function make() {
            return { name: "NULL" };
        }
        NullType.make = make;
    })(NullType = DataType.NullType || (DataType.NullType = {}));
    let BooleanType;
    (function (BooleanType) {
        function make() {
            return { name: "BOOLEAN" };
        }
        BooleanType.make = make;
    })(BooleanType = DataType.BooleanType || (DataType.BooleanType = {}));
    let FloatType;
    (function (FloatType) {
        function make() {
            return { name: "FLOAT" };
        }
        FloatType.make = make;
    })(FloatType = DataType.FloatType || (DataType.FloatType = {}));
    let IntegerType;
    (function (IntegerType) {
        function make() {
            return { name: "INTEGER" };
        }
        IntegerType.make = make;
    })(IntegerType = DataType.IntegerType || (DataType.IntegerType = {}));
    let DecimalType;
    (function (DecimalType) {
        function make(precision, scale) {
            return { precision, scale, name: "DECIMAL" };
        }
        DecimalType.make = make;
    })(DecimalType = DataType.DecimalType || (DataType.DecimalType = {}));
    let TimestampType;
    (function (TimestampType) {
        function make(unit = "MICROS") {
            return { unit, name: "TIMESTAMP" };
        }
        TimestampType.make = make;
    })(TimestampType = DataType.TimestampType || (DataType.TimestampType = {}));
    let DateTimeType;
    (function (DateTimeType) {
        function make(format = "ISO8601", unit = "MICROS") {
            return { name: "DATE_TIME", format, unit };
        }
        DateTimeType.make = make;
    })(DateTimeType = DataType.DateTimeType || (DataType.DateTimeType = {}));
    let StringType;
    (function (StringType) {
        function make() {
            return { name: "STRING" };
        }
        StringType.make = make;
    })(StringType = DataType.StringType || (DataType.StringType = {}));
    let RegexpType;
    (function (RegexpType) {
        function make() {
            return { name: "REGEXP" };
        }
        RegexpType.make = make;
    })(RegexpType = DataType.RegexpType || (DataType.RegexpType = {}));
})(DataType || (DataType = {}));
